module.exports = __webpack_public_path__ + "static/img/phone.a1fa2591.png";